import { combineReducers } from 'redux';

import dadosPreCadastroFormSave from './dadosPreCadastroFormSave/reducer';

export default combineReducers({
	dadosPreCadastroFormSave,
});
